import { useState } from "react";

interface Props {
  src: string;
  alt: string;
  fallbackInitials: string;
  fallbackText?: string;
  className?: string;
  showText?: boolean;
}

const PlatformLogo = ({ src, alt, fallbackInitials, fallbackText, className = "h-9", showText = false }: Props) => {
  const [imgError, setImgError] = useState(false);

  if (src && !imgError) {
    return (
      <img
        src={src}
        alt={alt}
        className={`${className} rounded-xl object-contain`}
        loading="eager"
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div className="flex items-center gap-2.5">
      <div className="w-9 h-9 rounded-xl bg-gradient-primary flex items-center justify-center shadow-glow shrink-0">
        <span className="text-primary-foreground font-bold text-sm">{fallbackInitials}</span>
      </div>
      {(showText || !src) && fallbackText && (
        <span className="font-display font-bold text-xl">{fallbackText}</span>
      )}
    </div>
  );
};

export default PlatformLogo;
